<template>
  <b-row>
    <form @submit.prevent  class="col-12 col-sm-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <b-row class="no-gutters form-project">
            <b-col cols="12">
              <b-row>
                <b-form-group class="col-6" label="Storefront:">
                  <b-v-select
                    id="form-input-projectId"
                    v-model="itemForm.projectId"
                    v-validate="{ required: true }"
                    :searchable="true"
                    :disabled="itemForm.id && itemForm.id.length > 0"
                    name="form-input-projectId"
                    :state="validateState('form-input-projectId')"
                    data-vv-as="Storefront"
                    :options="projectsList"
                  />
                  <b-form-invalid-feedback id="form-input-brandId-feedback">
                    {{ veeErrors.first('form-input-brandId') }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group class="col-6" label="Order Group Name:">
                  <b-form-input
                    id="form-input-storeName"
                    v-model="itemForm.storeName"
                    v-validate="{ required: true, min: 2 }"
                    name="form-input-storeName"
                    :disabled="itemForm.storeId && itemForm.storeId.length > 0"
                    :state="validateState('form-input-storeName')"
                    data-vv-as="Order Group Name"
                      />
                  <b-form-invalid-feedback id="form-input-storeName-feedback">
                    {{ veeErrors.first('form-input-storeName') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Status:" class="col-6"
                 v-if="itemForm.id && activeProject.integrationSystem == 'CartRoverThirdParty' && activeProject && activeProject.integrationStatus == 'Active'">
                  <b-v-select
                    v-model="itemForm.integrationStatus"
                    v-validate="{ required: true }"
                    :searchable="true"
                    name="form-input-integrationStatus"
                    :state="validateState('form-input-integrationStatus')"
                    :options="integrationStatusList"
                  >
                    <template v-slot:validationMsg>
                      <b-form-invalid-feedback
                        :id="'form-input-integrationStatus-feedback'"
                      >
                        {{ veeErrors.first('form-input-integrationStatus') }}
                      </b-form-invalid-feedback>
                    </template>
                  </b-v-select>
                </b-form-group>

                <template
                  v-if="!is('brand-user') && activeProject && activeProject.fulfillmentViaService == 'TPL' || activeProject.virtualFulfillmentViaService == 'TPL_MIRRORED'"
                >
                  <b-form-group class="col-12"  label="Extensiv Retailer:">
                    <b-v-select
                      v-model="itemForm.tplRetailerId"
                      v-validate="{ required: false }"
                      :searchable="true"
                      name="form-input-tplRetailerId"
                      :state="validateState('form-input-tplRetailerId')"
                      data-vv-as="Warehouse"
                      :options="tplRetailersList"
                    >
                      <template v-slot:validationMsg>
                        <b-form-invalid-feedback
                          :id="'form-input-tplRetailerId-feedback'"
                        >
                          {{ veeErrors.first('form-input-tplRetailerId') }}
                        </b-form-invalid-feedback>
                      </template>
                    </b-v-select>
                  </b-form-group>
                </template>
                <template
                  v-if="is('developer') && activeProject && activeProject.integrationSystem == 'CartRoverThirdParty'"
                >
                  <b-form-group class="col-6" label="CartRover Order Source ID (optional):">
                    <b-form-input
                      id="form-input-cartRoverOrderSource"
                      v-model="itemForm.cartRoverOrderSource"
                      v-validate="{ required: false }"
                      name="form-input-cartRoverOrderSource"
                      :state="validateState('form-input-cartRoverOrderSource')"
                      data-vv-as="CartRover Order Source ID"
                          />
                    <b-form-invalid-feedback id="form-input-cartRoverOrderSource-feedback">
                      {{ veeErrors.first('form-input-cartRoverOrderSource') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </template>

              </b-row>

            </b-col>
          </b-row>
        </div>
      </b-card>

    </form>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <b-button
          :disabled="savingItem"
          variant="primary"
          block
          type="submit"
          @click="SaveForm"
        >
          <span v-if="savingItem">Saving...</span>
          <span v-else>Save Changes</span>
        </b-button>
        <router-link
          :disabled="savingItem"
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'Storefronts.OrderGroups.Index' }"
        >
          <span>Cancel</span>
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [crudMixinGen('orderGroups'), myCommonDataMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    heading: 'Order Group Config',
    integrationStatusList: [
      { value: 'Active', text: 'Active' },
      { value: 'Paused', text: 'Paused' }
    ],
  }),

  computed: {
    tplRetailersList: {
      get() {
        let itmsList = [];
        if(this.itemForm.id) {
          let proj = this.myProjects.find(a =>a.id == this.itemForm.projectId);
          itmsList.push({ value: null, text: '- Use Storefront Default -' });
          if(proj != null) {
            let brandProj = this.myBrands.find(a =>a.id == proj.brandId);
            let myItems = this.$store.getters.getMyTPL.retailers;
            if(brandProj && myItems) {
              let tplCustId = brandProj.tplCustomerId;
              myItems = myItems.filter(a => a.tplCustomerId == tplCustId);
              myItems.forEach(itm => {
                itmsList.push({ value: itm.retailerNumber, text: itm.retailerNumber  +  ' (' + itm.description+ ')' });
              });
            }
          }
        }
        return itmsList;
      },
      set(val) {
      }
    },

    activeProject: {
      get() {
        let proj = false;
        if(this.itemForm.projectId) {
          proj = this.myProjects.find(a =>a.id == this.itemForm.projectId);
        }
        return proj;
      },
      set(val) {
      }
    },

  },

  mounted() {
    this.$store.dispatch('fetchMyTPLData');
    if (this.id) {
      this.ResetForm();
      this.LoadItem(this.id);
    } else {
      this.ResetForm();
      // let queryHas = this.$route.query;
      // if (queryHas) {
      // }
    }
  },

  methods: {
    SaveForm() {
      this.savingItem = true;
      this.SaveItem()
      .then(resp => {
        this.ResetForm();
        this.$swal({ title: 'Order Group saved!', icon: 'success' });
        this.$router.push({
          name: 'Storefronts.OrderGroups.Index'
        });
      })
      .catch(err => {
        this.savingItem = false;
        if (err.response && err.response.data && err.response.data.errorMessage) {
          this.$swal({ title: err.response.data.errorMessage, icon: 'error' });
        } else {
          this.$swal({ title: 'Item Was NOT Saved!', icon: 'error' });
        }
      });
    }
  }
};
</script>
